import _ from 'lodash'
import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Container, Form, Grid, Image, Segment } from 'semantic-ui-react'

import defaultAvatar from '../../assets/images/default-avatar.png'
import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import Navbar from '../navbar'
import { actions as messages } from '../../store/actions/messages'

class Password extends Component {
    constructor (props) {
        super(props)
        this.state = {
            oldPassword: '',
            newPassword: '',
            newPasswordRetyped: '',
            errors: {},
            doNotDisturb: false
        }
        autoBind(this)
    }

    // Changes the value of some field.
    changeValue (field, value) {
        this.setState({ [field]: value })
    }

    // Changes the therapist's password.
    changePassword () {
        // eslint-disable-next-line no-console
        console.log('Change password.')
        send({
            method: 'POST',
            tokens: this.props.userTokens,
            url: '/user/updatepassword',
            data: {
                old_password: this.state.oldPassword,
                new_password: this.state.newPassword
            }
        })
            .then((_response) => {
                // eslint-disable-next-line no-console
                console.log('Changed password.')
                this.setState({ doNotDisturb: false })
                // Go to the profile page.
                this.props.history.push('/profile')
            })
            .catch((error) => {
                // Failed to change password.
                // eslint-disable-next-line no-console
                console.error('Failed to change password.', error)
                let errors = {}
                if (error.message === '"Old password is not correct"') {
                    errors = {
                        oldPassword: tr('OLD_PASSWORD_WRONG')
                    }
                }
                this.setState({ doNotDisturb: false, errors })
                this.props.message({ type: 'error', text: tr('FAILED_TO_CHANGE_PASSWORD') })
            })
    }

    // Saves the new password.
    savePassword () {
        // Do not disturb.
        if (this.state.doNotDisturb) {
            return
        }

        // Put the do not disturb sign, and clear all errors.
        this.setState({ doNotDisturb: true, errors: {} })

        // Validate.
        let errors = {}

        // The old password is required.
        if (_.isEmpty(this.state.oldPassword)) {
            errors = {
                ...errors,
                oldPassword: tr('OLD_PASSWORD_REQUIRED')
            }
        }

        // The new password is required.
        if (_.isEmpty(this.state.newPassword)) {
            errors = {
                ...errors,
                newPassword: tr('NEW_PASSWORD_REQUIRED')
            }
        }

        // The new password must be at least 6 characters long.
        if (!_.isEmpty(this.state.newPassword) && !/^(((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*]))|((?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]))|((?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*]))).{8,}/.test(this.state.newPassword)) {
            errors = {
                ...errors,
                newPassword: tr('NEW_PASSWORD_NOT_VALID')
            }
        }

        // The new password must be retyped.
        if (_.isEmpty(this.state.newPasswordRetyped)) {
            errors = {
                ...errors,
                newPasswordRetyped: tr('NEW_PASSWORD_NEEDS_TO_BE_RETYPED')
            }
        }

        // The new password must have been typed correctly both times.
        if (!_.isEmpty(this.state.newPassword) && !_.isEmpty(this.state.newPasswordRetyped) && this.state.newPassword !== this.state.newPasswordRetyped) {
            errors = {
                ...errors,
                newPasswordRetyped: tr('PASSWORDS_NOT_MATCH')
            }
        }

        // There are errors. Break.
        if (!_.isEmpty(errors)) {
            this.setState({ doNotDisturb: false, errors })
            return
        }

        // Change the password.
        this.changePassword()
    }

    render () {
        return (<Container className='password'>
            <Navbar/>
            <Container className='gist'>
                <Segment className='center aligned picture'>
                    <Image src={this.props.picture
                        ? this.props.picture
                        : defaultAvatar} circular='circular' centered='centered'/>
                </Segment>
                <Grid className='segment centered'>
                    <Form>
                        <Segment className='instructions'>{tr('CHANGE_YOUR_PASSWORD')}</Segment>
                        <Form.Input name='oldPassword' type='password' label={tr('OLD_PASSWORD')}
                                    value={this.state.oldPassword}
                                    error={!_.isEmpty(this.state.errors) && !_.isEmpty(this.state.errors.oldPassword)}
                                    onChange={(e) => {
                                        this.changeValue(e.target.name, e.target.value)
                                    }}/> {!_.isEmpty(this.state.errors) && !_.isEmpty(this.state.errors.oldPassword) && (
                        <div className='error-message'>{this.state.errors.oldPassword}</div>)}
                        <Form.Input name='newPassword' type='password' label={tr('NEW_PASSWORD')}
                                    value={this.state.newPassword}
                                    error={!_.isEmpty(this.state.errors) && !_.isEmpty(this.state.errors.newPassword)}
                                    onChange={(e) => {
                                        this.changeValue(e.target.name, e.target.value)
                                    }}/> {!_.isEmpty(this.state.errors) && !_.isEmpty(this.state.errors.newPassword) && (
                        <div className='error-message'>{this.state.errors.newPassword}</div>)}
                        <Form.Input name='newPasswordRetyped' type='password' label={tr('RETYPE_NEW_PASSWORD')}
                                    value={this.state.newPasswordRetyped}
                                    error={!_.isEmpty(this.state.errors) && !_.isEmpty(this.state.errors.newPasswordRetyped)}
                                    onChange={(e) => {
                                        this.changeValue(e.target.name, e.target.value)
                                    }}/> {!_.isEmpty(this.state.errors) && !_.isEmpty(this.state.errors.newPasswordRetyped) && (
                        <div className='error-message'>{this.state.errors.newPasswordRetyped}</div>)}
                        <Form.Button onClick={(_e) => {
                            this.savePassword()
                        }}>
                            {tr('SAVE')}
                        </Form.Button>
                    </Form>
                </Grid>
            </Container>
        </Container>)
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        picture: state.profiles.profile.picture,
        timezone: state.settings.timezone,
        userTokens: state.users.userTokens
    }
}

const mapDispatchToProps = (dispatch) => {
    const _messages = bindActionCreators(messages, dispatch)
    return { message: _messages.message }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Password))



// WEBPACK FOOTER //
// ./src/components/password/index.js